import { addLesson } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useAddLesson = () => {
    const { callAPI, loading } = useWorkspaceApiCall(addLesson, 'addLesson.success', 'addLesson.error');

    return { addLesson: callAPI, addingLesson: loading };
}